/**
 * Created by Hardy on 2017/7/8.
 */
//一些静态数据
const departmentData = [
  {
    value : '儿科',
    text : '儿科'
  },
  {
    value : '呼吸科',
    text : '呼吸科'
  },
  {
    value : '小儿呼吸科',
    text : '小儿呼吸科'
  },
  {
    value : '哮喘中心',
    text : '哮喘中心'
  },
  {
    value : '急诊科',
    text : '急诊科'
  },
  {
    value : '过敏反应科',
    text : '过敏反应科'
  },
  {
    value : '其他科室',
    text : 'null'
  }
]
const levelData = [
  {
    value : '住院医师',
    text : '住院医师'
  },
  {
    value : '主治医师',
    text : '主治医师'
  },
  {
    value : '副主任医师',
    text : '副主任医师'
  },
  {
    value : '主任医师',
    text : '主任医师'
  },
  {
    value : '教授',
    text : '教授'
  },
  {
    value : '其他职称',
    text : '其他职称'
  }
]
const peopleCount = function () {
  let data = [{value : '0' , text : '不接受网上预约'}]
  for (let i = 1; i < 21; i++) {
    var obj = {
      value : i.toString(),
      text : i.toString()
    }
    data.push(obj);
  }
  return data;
}
const newReportData = function () {
  let timeData = [];
  for (let i = 0; i < 25; i++) {
    let obj = {
      value : i.toString(),
      text : i.toString(),
      children : []
    };
    for (let j = 0; j < 25; j++) {
      let obj1 = {
        value : j.toString(),
        text : j.toString()
      };
      obj.children.push(obj1);
    }
    timeData.push(obj);
  }
  return timeData;
}
const replyData = [
  {
    id : '',
    content : '您好！请问您或者您的孩子多大了，男性还是女性呢？是否有确诊哮喘？患病多久了？'
  },{
    id : '',
    content : '请问您或者您的孩子目前早晚检测PEF最佳值是多少？近两周的PEF检测数据是否有低于80%？可以发送检测数据给我分析查看？'
  },{
    id : '',
    content : '您或者您的孩子现在是否用用药？有的话，请提供药物名称或者将药盒拍照上传？每天的用药方案是怎么样的，用药后有没有异常或不舒服？'
  },{
    id : '',
    content : '您或者您的孩子平时饮食、运动情况是怎么安排的，哮喘病情有没有影响到日间或者夜间活动？'
  },{
    id : '',
    content : '建议坚持使用肺功能仪连续检测PEF指标，每天早晨起床后和晚上睡觉前，各检测一次，每次检测三遍，记录三次中的最佳PEF值，连续两周可以反应您或您的孩子的病情控制情况和指导用药。'
  },{
    id : '',
    content : '您好！对于您提供的情况缺乏必要的了解，建议线下就诊，以便于给您提供更有针对性的建议。'
  },{
    id : '',
    content : '您好！由于您上传的图片不清晰，为给您更准确的诊断，请重新上传。'
  },{
    id : '',
    content : '您好！如果今后有健康相关的问题，欢迎咨询，祝平安健康！生活愉快！'
  }
]

const constultCount = [
  {
    value : '3',
    text : '3'
  },
  {
    value : '5',
    text : '5'
  },
  {
    value : '10',
    text : '10'
  },
  {
    value : '15',
    text : '15'
  },
  {
    value : '20',
    text : '20'
  }
]

const questions = [
  {
    id : 'q1',
    content : '对医生服务质量不满意，申请退款'
  },{
    id : 'q2',
    content : '没有收到退款'
  },{
    id : 'q3',
    content : '医生未回复、回复不及时、催租回复'
  },{
    id : 'q4',
    content : '平台功能建议'
  },{
    id : 'q5',
    content : '对我们的服务不满意'
  }
]
const bank = [
  {
    id : '0308',
    name : '招商银行'
  },
  {
    id : '0102',
    name : '工商银行'
  },
  {
    id : '0103',
    name : '农业银行'
  },
  {
    id : '0104',
    name : '中国银行'
  },
  {
    id : '0105',
    name : '建设银行'
  },
  {
    id : '0301',
    name : '交通银行'
  },
  {
    id : '0100',
    name : '中国邮政'
  },
  {
    id : '0302',
    name : '中信银行'
  },
  {
    id : '0303',
    name : '光大银行'
  },
  {
    id : '0309',
    name : '兴业银行'
  },
  {
    id : '0310',
    name : '浦发银行'
  },
  {
    id : '0306',
    name : '广发银行'
  },
  {
    id : '0401',
    name : '上海银行'
  },
  {
    id : '0403',
    name : '北京银行'
  },
  {
    id : '0304',
    name : '华夏银行'
  },
  {
    id : '0305',
    name : '民生银行'
  }
]

const wechat = [
  {
    id : 'q1',
    content : '微信支付未进行实名认证会有什么影响？'
  },{
    id : 'q2',
    content : '如何主动进行微信支付实名认证？'
  },{
    id : 'q3',
    content : '如何知道自己微信支付是否已经实名？'
  },{
    id : 'q4',
    content : '微信支付没有银行卡怎么进行实名认证？'
  },{
    id : 'q5',
    content : '微信支付为什么要进行实名认证？'
  }
]
const fServiceIntro = [
  {
    class : 't2',
    content : '图文咨询（按期）介绍',
    p : [
      {
        content : '图文咨询（按期）是在智呼吸平台注册并认证的医师向加入医生个人工作室的会员提供的一种较长期的中高端个性化医疗咨询服务。会员订购服务后，服务期限内可以不限次数的向医生咨询，并享有对后来的其他付费的项目如付费订阅的知识文章、讲课等等免费观看的权利。可以优先申请医生门诊预约资格（医生如有开通服务）。医生也可主动关心或询问会员情况，解决会员日常健康咨询，就诊、诊后复查等问题，建立长期关系。'
      }
    ]
  },
  {
    class : 't2',
    content : '如何设置图文咨询（按期）服务？',
    p : [
      {
        content : '进入智呼吸医生工作室主页，选择“服务设置”→“图文咨询（按期）”，设置图文咨询（按期）服务内容'
      },
      {
        class : 't3',
        content : '设置价格'
      },
      {
        content : '您可以在“价格设置”中选择服务定价：299元/月，499元/月，699元/月，999元/月或者自定义价格（最高设置2000元/月）。'
      },
      {
        content : '请综合考虑以下因素设定价格：您的职称、会员的病情与付费能力。'
      },
      {
        class : 't3',
        content : '服务时长选择：'
      },
      {
        content : '您可以选择开通图文咨询（按期）服务时长，可分别选择开通1个月、3个月、半年、全年时长的服务，默认至少开通一种。'
      }
    ]
  },
  {
    class : 't2',
    content : '会员如何付费？',
    p : [
      {
        content : '会员通过扫码医生二维码或平台搜索方式加入医生工作室，会在医生主页看到您所提供的服务与相应的价格，选择需要付费服务，可以通过微信支付的方式发起订购。'
      },
    ]
  },
  {
    class : 't2',
    content : '付费后使用事项',
    p : [
      {
        content : '智呼吸平台对于会员付费后，会给医生发送通知消息和付费标记，您可以根据提示进行回复和会员管理：'
      },
      {
        content : '<span style="color: #66acff">1）</span>会员订购服务后，会有微信消息和短信消息及时提醒医生；'
      },
      {
        content : '<span style="color: #66acff">2）</span>进入智呼吸医生工作室首页点击【我的咨询】按钮可以查看和回复所有咨询问题；'
      },
      {
        content : '<span style="color: #66acff">3）</span>会员主动咨询在“消息”页面会有待回复消息提示，可以选择查看和直接回复；'
      },
      {
        content : '<span style="color: #66acff">4）</span>会员申请预约门诊会在【我的预约】页面中的“待审核”中查看，可处理会员预约申请；'
      },
      {
        content : '<span style="color: #66acff">5）</span>在【我的会员】页面中有‘VIP会员’分组，已经付费的会员会在该分组内，并对付费项目具有标记；您也可以查看与会员的“服务记录”，查看当前服务项目和剩余情况等详情。'
      },
    ]
  },
  {
    class : 't2',
    content : '如何知道有待回复咨询',
    p : [
      {
        content : '智呼吸平台对于会员的咨询信息或通话申请均会给医生发送事项通知，您可以根据提示进行回复处理。'
      }
    ]
  },
  {
    class : 't2',
    content : '如何处理会员咨询？',
    p : [
      {
        content : '我们会发送消息通知医生需要回复的咨询，图文咨询（按期）会员作为您的VIP用户，建议您优先处理回复，有时候实在太忙，没有时间回复会员消息，我们会及时通知会员医生可能仍在忙碌中，请耐心等待。平时医生也可动关心或询问图文咨询（按期）会员情况，建立长期关系。我们可以在会员订购时告知会员，图文咨询（按期）咨询服务仅限于会员与医生日常咨询交流、不可完全替代处方、门诊等治疗方式。如病情紧急，请立刻前往医院就医。'
      }
    ]
  },
  {
    class : 't2',
    content : '如何处理服务纠纷？',
    p :[
      {
        content : '图文咨询（按期）会员是医生的VIP用户，同一订单用户如果医生长期未及时回复、不回复或服务被投诉，经平台确认超过3次以上，会员有权利向平台申诉，我们将与医生和会员进行三方协调并确认，如需取消订单，我们将根据医生最后一次有效服务日期为准，按服务使用时长计算退款退还给会员。'
      },
      {
        content : '整体图文咨询（按期）订单，连续投诉超过3次并经核实确认，平台将限制医生继续提供收费性质的咨询服务，请悉知。'
      }
    ]
  },
  {
    class : 't2',
    content : '资费如何结算',
    p : [
      {
        content : '图文咨询（按期）的服务周期较长，服务资费采用按月分期结算的方式。服务相应资费会计入智呼吸平台医生待结算金额中，医生可以在“我的收入”中查看。每个服务订单满1个月后，服务相应资费除以服务月数的当月资费自动转入可提现余额，您可以选择银行卡、微信方式提现。提现操作在[ 我的收入 ] → [ 提现 ]提交申请。'
      },
    ]
  }
]
const iServiceIntro = [
  {
    class : 't2',
    content : '图文咨询（按次）介绍',
    p : [
      {
        content : '图文咨询（按次）是在智呼吸平台注册并认证的医师向加入医生个人工作室的会员提供的一次性收费的在线咨询服务，会员订购服务后，以文字、图片形式向医生咨询。医生开通服务时可设置会员每次回复条数，会员订购服务后，发送想要咨询的问题，服务的回复有效期为48小时，若在规定时间内，医生回复会员的咨询问题，则收取对应的资费；若超出48小时未回复，平台自动取消服务订单，订单资费全部退还给会员，医生和会员均不受任何损失。'
      },
      {
        content : '<span style="color: red">注意：</span>智呼吸平台仅为与会员线上咨询、交流，不能够完全替代处方、诊断和治疗方案。'
      },
    ]
  },
  {
    class : 't2',
    content : '如何设置图文咨询（按次）？',
    p : [
      {
        content : '进入智呼吸医生工作室主页，选择“服务设置”→“图文咨询（按次）”，设置图文咨询（按次）服务内容'
      },
      {
        class : 't3',
        content : '设置价格：'
      },
      {
        content : '您可以在“价格设置”中选择服务定价：19元/次，49元/次，99元/次，149元/次或者自定义价格（最高设置300元/次）。'
      },
      {
        content : '请综合考虑以下因素设定价格：您的职称、会员的病情与付费能力。'
      },
      {
        class : 't3',
        content : '设置回复条数：'
      },
      {
        content : '您可以在“每次回复条数”中选择会员每次可回复消息条数：3条，5条，10条，15条，20条。'
      },
      {
        content : '希望能够为会员提供优质、定价适中的咨询服务。'
      },
    ]
  },
  {
    class : 't2',
    content : '付费后事项？',
    p : [

      {
        content : '智呼吸平台对于会员付费后，会给医生发送通知消息和付费标记，您可以根据提示进行回复和会员管理：'
      },
      {
        content : '<span style="color: #66acff">1）</span>会员订购服务后，会有微信消息和短信消息及时提醒医生；'
      },
      {
        content : '<span style="color: #66acff">2）</span>进入智呼吸医生工作室首页点击【我的咨询】按钮可以查看和回复所有咨询问题；'
      },
      {
        content : '<span style="color: #66acff">3）</span>会员主动咨询在“消息”页面会有待回复消息提示，可以选择查看和直接回复；'
      },
      {
        content : '<span style="color: #66acff">4）</span>在“通讯录”页面中有‘付费会员’分组，已经付费的会员会在该分组内，并对付费项目具有标记；您也可以查看与会员的“服务记录”，查看当前服务项目和剩余情况等详情。'
      },
    ]
  },
  {
    class : 't2',
    content : '如何知道有待回复咨询',
    p : [

      {
        content : '智呼吸平台对于会员的咨询信息会给医生发送咨询通知，您可以根据提示进行回复。'
      },
    ]
  },
  {
    class : 't2',
    content : '图文咨询（按次）订单未超时未回复怎么办？',
    p :[
      {
        content : '我们会发送消息通知医生需要回复的咨询，若医生太忙，没有回复会员消息，我们会及时通知会员医生可能仍在忙碌中，请耐心等待；'
      },
      {
        content : '<span style="color: #66acff">1）</span>如果是新的咨询订单，医生超过48小时没能回复会员，平台自动取消服务订单，订单资费全部退还给会员，医生和会员均不受任何损失。如果等您有空时，仍愿意帮助会员提供咨询，可以给会员设置免费的随访，回复他的疑问，会员以后会更有意愿使用付费咨询；'
      },
      {
        content : '<span style="color: #66acff">2）</span>如果是已经回复过的咨询订单，在后续的回复中会员超过48小时未能得到回复，会员可以向平台申诉，我们将与医生和会员进行三方协调，取消服务订单，并退还全部资费给会员。'
      },

    ]
  },
  {
    class : 't2',
    content : '会员咨询条数用完了，问题没有解决怎么办？',
    p : [
      {
        content : '可以在与会员咨询的“服务记录”中，修改当前免费咨询的条数，修改会员的咨询剩余条数或时间，此设置不另外向会员收费，为医生为会员设置免费咨询服务。'
      },

    ]
  },
  {
    class : 't2',
    content : '资费如何结算',
    p :[
      {
        content : '会员订购服务后，服务相应资费会计入智呼吸平台医生待结算金额中，医生可以在“我的收入”中查看。服务订单结束7天内确认订单，服务相应资费自动转入可提现余额，您可以选择银行卡、微信方式提现。提现操作在[ 我的收入 ] → [ 提现 ]提交申请。'
      }

    ]
  },
]
const oServiceIntro =[
  {
    class : 'title',
    content : '智呼吸门诊预约须知'
  },
  {
    content : '',
    p : [
      {
        content : '欢迎使用智呼吸哮喘管理平台，您在门诊预约服务前，请仔细阅读本须知：'
      }
    ]
  },
  {
    content : '',
    p : [
      {
        content : '1.智呼吸哮喘管理平台门诊预约是医生为会员提供预约门诊的一项服务，在智呼吸平台注册并认证的医生有开通或停止此项服务的权利。'
      }
    ]
  },
  {
    content : '',
    p : [
      {
        content : '2.智呼吸平台在线门诊预约服务是医生在正常门诊挂号之外，医生牺牲休息时间延长门诊时间，为病情需要的会员提供的额外加号就诊机会，是医生的个人行为，与医院无关，门诊预约不占用医院正常挂号资源。'
      }
    ]
  },
  {
    content : '',
    p : [
      {
        content : '3.用户须填写就诊人的病情资料（包括就诊人的基本资料、病情描述等信息），所有信息必须真实，提交并由医生确认后用户才可获得预约机会。'
      }
    ]
  },
  {
    content : '',
    p : [
      {
        content : '4.用户获得预约资格后，到预约门诊地址找到医生并得到医生确认，拿到医生开具的加号单后到挂号处挂号，然后返回门诊等待叫号，排队就诊。'
      }
    ]
  },
  {
    content : '',
    p : [
      {
        content : '5.预约成功以智呼吸微信公众号消息通知为准，同时会发送预约成功短信通知。如因用户本人操作或手机自动屏蔽通知而导致的用户未收到通知信息，智呼吸平台和医生个人均不承担任何责任。'
      }
    ]
  },
  {
    content : '',
    p : [
      {
        content : '6.成功申请门诊预约的用户有权利在就诊日期前一天18:00之前取消预约，如未取消预约且未履约，将被记作爽约记录。一旦您出现爽约记录，智呼吸平台保留限制爽约用户再次使用门诊预约服务的权利。'
      }
    ]
  },
  {
    content : '',
    p : [
      {
        content : '7.预约门诊加号如遇医生遇到抢救、急诊等特殊事件时，医生可以延后甚至取消门诊，我们会在获悉后第一时间通知用户，出诊时间以医院当日公布出诊日期为准，并通知用户选择其他时间再次预约。<br>由此产生的以下问题智呼吸平台、医生、医院均不承担任何赔偿责任：<br>交通、餐饮、住宿等费用<br>会员延误门诊导致的病情延误<br>以及其他由于门诊延误导致的问题'
      }
    ]
  },
  {
    content : '',
    p : [
      {
        content : '8.智呼吸平台提供的门诊预约是免费的服务，仅特指线上预约服务不收取费用，不包括线下医院必须缴纳的挂号费、检查费、治疗费以及药品购买等费用。且智呼吸平台不对医院及医生的就医费用、诊疗效果、等其他后果承担责任。'
      }
    ]
  }
]
const agreement = [
  {
    class : 'title',
    content : '智呼吸注册服务协议',
    p :[
      {
        content : '“智呼吸”，包括但不限于微信和APP，是上海合微智能科技有限功能（以下简称“上海合微”或甲方）专门为医生（以下简称“医生”或乙方）和会员用户（以下简称“用户”）开发的移动应用，医生利用它对已熟悉的用户进行线上的交流和随访管理等工作，为进一步补充和完善更充分的医患交流，建立和谐医患关系。在注册成为智呼吸的乙方或用户，并开始使用智呼吸之前，请务必仔细阅读并理解《服务协议》（以下简称“本协议”）中规定的所有权利和限制。乙方或用户需确认已经阅读本协议，并同意本协议中所有条款。一旦乙方或用户开始使用智呼吸，那么本协议中的所有条款即分别在上海合微和医生、上海合微和用户之间生效，与合同具有同等法律效力。'
      }
    ]
  },
  {
    class : 't2',
    content : '1.服务内容',
    p : [
      {
        content : '上海合微负责在“智呼吸”上为医生和用户建立随访管理及交流的虚拟环境，并提供技术与服务支持。'
      },
      {
        content : '上海合微有义务保护医生和用户的个人资料及隐私信息（需要公布的资料和信息除外）的安全，不得泄露医生或用户的隐私资料。'
      },
      {
        content : '乙方有义务保证提交的所有注册信息必须真实准确，上海合微承诺对个人登录信息保密、不被其他人获取与使用，并且对乙方在本网站账户下的所有行为负责。'
      },
      {
        content : '乙方授权甲方在“智呼吸”应用上向用户展示以乙方姓名冠名的相关介绍，并在智呼吸应用中开展订购形式的个性化交流服务；'
      },
      {
        content : '乙方或用户在使用“智呼吸”时，均需接受上海合微的免责协议：“智呼吸”中所有医疗信息、图文影像信息、交流，咨询信息等皆不作为诊断结果和医疗的证据，用户只能作为参考。上海合微不承担医生或用户在使用智呼吸平台时可能产生的医疗风险和责任。用户应及时与医生沟通并确保相关资料和信息及时、准确上传。在使用平台服务的过程中，如遇医生回复延迟，会员（尤其是病情严重或发生急性症状和化验结果异常的情形下）建议尽快前往医院就医。'
      }
    ]
  },
  {
    class : 't2',
    content : '2.智呼吸使用规范',
    p : [
      {
        content : '医生或用户在智呼吸使用中的言行需遵守国家法律、法规等规范性文件及上海合微的各项规则和要求，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本协议及相关规则。如果因此产生任何法律后果，医生或用户应独立承担法律责任。'
      },
      {
        content : '医生在智呼吸平台不得以任何形式提供除咨询外的医学帮助，且不得影响医生所属医疗机构中的本职工作及其管理规章。医生承诺，对其提供咨询交流服务的用户的任何附随诊断及治疗活动，应在医疗执业机构内进行。在线咨询服务不可替代诊后随访等诊断与治疗服务，医生或用户不应将在线咨询完全代替处方、诊断、治疗方案使用，并应自行承担由此产生的相应后果和法律责任。因医生违反使用规范而使上海合微与用户，或医生与所属医疗机构产生纠纷的，由医生自行承担，上海合微不负任何法律责任。'
      },
      {
        content : '用户通过智呼吸平台能且仅能获得咨询服务（包括医学信息，健康知识，医疗健康咨询建议等符合法律规定且智呼吸平台所允许的咨询服务事项），且因咨询均只限于根据用户的主观描述，医生尽可能利用医学知识及相关经验给予一定的解惑及建议，但无法对结果是否符合用户预期做保证。'
      },
      {
        content : '在使用智呼吸的过程中，如果发生不当使用情况，医生或用户可以通过以下方式向智呼吸提出投诉或举报：发送邮件至service@hiwein.com，并提供上述事件的必要证据材料。智呼吸在收到投诉或举报后，可根据投诉情况选择调解、警告等处理方式。对于无法证实投诉或举报内容真实性的，智呼吸及时向投诉人或举报人告知情况。智呼吸作为平台方仅协助各方处理争议及投诉举报内容，任何该等事件参与人应自行对该等事件独立承担法律责任，智呼吸对此不承担任何责任。'
      }
    ]
  },
  {
    class : 't2',
    content : '3. 协议内容',
    p : [
      {
        content : '本协议内容包括协议正文及所有上海合微已经发布的或将来可能发布的各类规则。所有规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。医生或用户应当在使用智呼吸应用服务之前认真阅读全部协议内容。因此，只要乙方或用户使用智呼吸服务，则本协议即对乙方或用户产生法律约束力。'
      },
      {
        content : '上海合微有权根据需要定期制订、修改本协议和/或各类规则，并会提前在上海合微官方网站或“智呼吸”应用中进行公示。上海合微更新后，变更的协议和规则立即自动生效。如乙方或用户继续使用智呼吸服务，即表示接受经修订的协议和规则。'
      }
    ]
  },
  {
    class : 't2',
    content : '4. 注册',
    p : [
      {
        content : '注册者资格：乙方或用户在完成注册程序或实际使用智呼吸服务时，应当是具备完全民事权利能力和完全民事行为能力的自然人，且乙方同时必须拥有中华人民共和国《执业医师资格证》。若乙方不具备前述主体资格，则乙方应承担因此而导致的一切后果，且上海合微有权注销（永久冻结）乙方的智呼吸账户，由此造成的损失，上海合微有权向乙方索偿。'
      },
      {
        content : '账户：乙方应对自己的智呼吸账户和密码的安全负责。除非有法律规定或司法裁定，且征得上海合微的同意，否则，账户不得以任何方式转让、赠与或继承。如果发现任何人不当使用乙方账户或有任何其他可能危及乙方账户安全的情形时，乙方应当立即以有效方式通知上海合微，要求上海合微暂停相关服务。乙方向上海合微提供所需注册资料、阅读并同意本协议、完成全部注册程序后，即成为智呼吸上的注册医生。在后续的使用过程中，乙方应当及时更新自己的资料，以使之真实、及时，完整和准确。医生如使用账户及服务中的收费功能，应基于真实合法的咨询服务取得合理对价，不得利用平台从事违反法律规定或医师执业道德准则的收费行为。'
      }
    ]
  },
  {
    class : 't2',
    content : '5.协议终止',
    p : [
      {
        content : '乙方或用户对上海合微有任何意见和建议均可通过客服电话、电子邮件等渠道联系进行反馈。上海合微将充分尊重乙方或用户的意见，经协商达成一致后，对协议或规则进行调整。'
      },
      {
        content : '智呼吸有权对平台上医生或用户发布的内容进行监督，发现不符合法律法规、道德准则、医生/用户规则的内容，智呼吸有权利予以屏蔽或删除，并保留对责任人所使用的智呼吸账户予以暂停使用、冻结直至取消该账户资格的权利。若乙方或用户屡次违反本协议或相关规定，经上海合微提醒仍不改变；或因乙方或用户的言行对上海合微造成重大损失的，上海合微有权终止与乙方或用户的协议，并冻结乙方或用户的账号。'
      }
    ]
  },
  {
    class : 't2',
    content : '6.责任限制',
    p : [
      {
        content : '乙方或用户理解并同意自主选择、使用智呼吸并风险自负。上海合微不承担因用户自身过错、网络状况、通讯线路等任何技术原因或其他不可控原因而导致不能正常使用“智呼吸”服务以及因此引起的损失，亦不承担任何法律责任。'
      }
    ]
  },
  {
    class : 't2',
    content : '7.免担保声明',
    p : [
      {
        content : '应用内容和服务的提供以“当前可获得”为基础。上海合微不确保提供无错误的任何默示保证。对于本应用、本应用内容、通过本应用获得的任何建议或者服务，上海合微明确表示不提供任何保证，不论明示的或暗示的，包括但不限于适销性、适用性、可靠性、准确性及完整性。上海合微不能够担保服务一定能满足乙方或用户的要求，也不担保服务不会被修改、中断或终止，并且对服务的及时性、安全性及错误发生均不作任何担保。乙方或用户自行承担使用本应用内容所'
      }
    ]
  },
  {
    class : 't2',
    content : '8.法律适用、管辖与其他',
    p : [
      {
        content : '本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律，如无相关法律规定的，则应参照通用国际商业惯例和（或）行业惯例。'
      },
      {
        content : '因本协议产生之争议，应依照中华人民共和国法律予以处理。'
      },
      {
        content : '甲方和乙方或用户本着相互理解的态度执行本协议，如遇任何问题和矛盾可协商调解，如协商不成，可向甲方所在地法院提请诉讼。'
      },
      {
        content : '未尽事宜，则由相互协商确定。'
      }
    ]
  }

]
export {
  departmentData,
  levelData,
  peopleCount,
  newReportData,
  replyData,
  constultCount,
  questions,
  bank,
  wechat,
  fServiceIntro,
  iServiceIntro,
  oServiceIntro,
  agreement
}



// WEBPACK FOOTER //
// ./src/data/data.js